/* SPLENDIDO — filtri della pagina categoria · 2026-09-11
   ----------------------------------------------------------------------------
   Tutto in delega su `document`: Prestige, a ogni cambio di filtro, sostituisce
   l'INTERA sezione (replaceChildren), quindi niente listener sugli elementi.

   1) Chip di gruppo (Gelbgold = 1 valore, Bicolor = 2 valori, Farbstein = 7…):
      la casella visibile non ha `name`; copia il suo stato sulle caselle vere
      nascoste dello stesso gruppo. In fase di CATTURA, così avviene PRIMA che
      `facets-form` legga il form e ricarichi.
   2) Chip per tag (Unikate, Anlass, ohne Stein) e fasce di prezzo: il link
      porta solo il percorso; qui gli aggiungiamo i filtri/ordinamento correnti
      (location.search) al clic, prima che `facet-link` lo legga.
   3) Tendine: una sola aperta alla volta; si chiudono cliccando fuori o con Esc. */
(function () {
  'use strict';
  if (window.__spFiltersInit) return;
  window.__spFiltersInit = true;

  /* 1) chip di gruppo */
  document.addEventListener('change', function (e) {
    var vis = e.target;
    if (!vis || !vis.matches || !vis.matches('.sp-chip__in[data-sp-group]')) return;
    var g = vis.getAttribute('data-sp-group');
    var form = vis.closest('form') || document;
    var reali = form.querySelectorAll('input[data-sp-in-group="' + g + '"]');
    for (var i = 0; i < reali.length; i++) reali[i].checked = vis.checked;
    var chip = vis.closest('.sp-chip'); if (chip) chip.classList.toggle('is-on', vis.checked);
  }, true);

  /* aspetto delle chip con radio/checkbox normali (Sofort lieferbar, ordinamento) */
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('.sp-chip__in:not([data-sp-group])')) return;
    var chip = inp.closest('.sp-chip'); if (!chip) return;
    if (inp.type === 'radio') {
      var form = inp.closest('form') || document;
      form.querySelectorAll('input[name="' + inp.name + '"]').forEach(function (r) { var c = r.closest('.sp-chip'); if (c) c.classList.toggle('is-on', r.checked); });
    } else chip.classList.toggle('is-on', inp.checked);
  }, true);

  /* 2) link per tag e fasce di prezzo: conservano filtri e ordinamento correnti */
  function conServa(href, opz) {
    try {
      var u = new URL(href, location.origin);
      var cur = new URLSearchParams(location.search);
      cur.delete('page'); cur.delete('section_id');
      if (opz && opz.prezzo) { cur.delete('filter.v.price.gte'); cur.delete('filter.v.price.lte'); }
      var mine = new URLSearchParams(u.search);
      mine.forEach(function (v, k) { cur.set(k, v); });
      u.search = cur.toString();
      return u.toString();
    } catch (err) { return href; }
  }
  /* pillola di gruppo: la × toglie TUTTI i valori del gruppo (Bicolor = 2 valori, Farbstein = 7) */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[data-sp-remove]');
    if (!a) return;
    try {
      var u = new URL(location.href);
      u.searchParams.delete('page');
      a.getAttribute('data-sp-remove').split('|').forEach(function (pair) {
        if (!pair) return;
        var i = pair.indexOf('='); var k = pair.slice(0, i), v = pair.slice(i + 1);
        var rest = u.searchParams.getAll(k).filter(function (x) { return x !== v; });
        u.searchParams.delete(k); rest.forEach(function (x) { u.searchParams.append(k, x); });
      });
      a.href = u.toString();
    } catch (err) {}
  }, true);

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[data-sp-tag-link], a[data-sp-price]');
    if (!a) return;
    var isPrezzo = a.hasAttribute('data-sp-price');
    if (isPrezzo && a.classList.contains('is-on')) {
      /* fascia già attiva: il clic la toglie */
      var u = new URL(a.href, location.origin); u.search = ''; a.href = conServa(u.toString(), { prezzo: true });
    } else {
      a.href = conServa(a.href, { prezzo: isPrezzo });
    }
  }, true);

  /* 3) tendine */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details.sp-dd') || !d.open) return;
    document.querySelectorAll('details.sp-dd[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('details.sp-dd')) return;
    document.querySelectorAll('details.sp-dd[open]').forEach(function (o) { o.open = false; });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('details.sp-dd[open]').forEach(function (o) { o.open = false; });
  });

  /* 4) telefono (capo 11/09, variante A): la tendina è una scheda dal basso.
        - tocco sul velo scuro: il velo è lo ::before del <details>, quindi il bersaglio del clic è il <details> stesso → chiudi;
        - una scelta (casella, radio, chip-link) applica il filtro e chiude subito la scheda, come chiesto dal capo. */
  var spMobile = window.matchMedia('(max-width: 999px)');
  document.addEventListener('click', function (e) {
    if (!spMobile.matches) return;
    var t = e.target;
    if (t && t.matches && t.matches('details.sp-dd[open]')) { t.open = false; return; }
    var a = t && t.closest && t.closest('.sp-dd__pop a.sp-chip');
    if (a) { var d = a.closest('details.sp-dd'); if (d) setTimeout(function () { d.open = false; }, 120); }
  });
  /* SPLENDIDO 2026-10-15 (capo, foto iPhone): su Safari iPhone la scheda e il velo (position: fixed) restavano ritagliati
     dentro la riga scorrevole dei chip (overflow-x: auto) → riga grigia o lista che scorre dentro la riga; „Sortieren",
     fuori dalla riga, funzionava. Con una scheda aperta la riga smette di essere scorrevole (overflow visibile) e
     `left` negativo la tiene ferma dove l'aveva lasciata il dito (`left` non cambia il riferimento dei figli fissi,
     un transform sì); alla chiusura tutto torna com'era, con lo stesso scorrimento. Chrome non ritaglia: lì non cambia nulla. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details.sp-dd')) return;
    var row = d.closest('.sp-fbar__row');
    if (!row) return;
    if (d.open && spMobile.matches) {
      if (row.__spAperta) return;
      var x = row.scrollLeft;
      row.__spAperta = true; row.__spX = x;
      row.style.overflow = 'visible'; row.style.position = 'relative'; row.style.left = (-x) + 'px';
    } else if (!d.open && row.__spAperta && !row.querySelector('details.sp-dd[open]')) {
      row.__spAperta = false;
      row.style.overflow = ''; row.style.position = ''; row.style.left = '';
      row.scrollLeft = row.__spX || 0;
    }
  }, true);
  document.addEventListener('change', function (e) {
    if (!spMobile.matches) return;
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('.sp-dd__pop input[type="checkbox"], .sp-dd__pop input[type="radio"]')) return;
    var d = inp.closest('details.sp-dd');
    if (d) setTimeout(function () { d.open = false; }, 120);
  });

  /* 5) SPLENDIDO 2026-09-26 (audit NAV-06, ok capo) — telefono, schede a scelta multipla (Material, Stein…):
        le caselle NON applicano più il filtro a ogni tocco. Si spuntano più valori e si conferma con „Anwenden";
        „Schließen", il velo o Esc chiudono e rimettono le caselle com'erano all'apertura.
        Come: in fase di CATTURA su document (dopo i gestori 1 e „aspetto delle chip", registrati prima) si ferma
        la propagazione del `change`, così `facets-form` non ricarica; „Anwenden" rilancia un `change` sul form. */
  function schedaMultipla(d) { return !!(d && d.querySelector('[data-sp-dd-apply]')); }
  function caselle(d) { var f = d.closest('form'); return f ? f.querySelectorAll('input[type="checkbox"]') : []; }
  function ridisegna(inp) { var c = inp.closest('.sp-chip'); if (c) c.classList.toggle('is-on', inp.checked); }

  document.addEventListener('change', function (e) {
    if (!spMobile.matches || window.__spFiltriApplica) return;
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('.sp-dd__pop input[type="checkbox"]')) return;
    var d = inp.closest('details.sp-dd');
    if (!schedaMultipla(d)) return;
    d.setAttribute('data-sp-dirty', '1');
    e.stopPropagation();
  }, true);

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details.sp-dd') || !schedaMultipla(d)) return;
    if (d.open) {
      /* fotografia delle caselle all'apertura */
      d.__spFoto = Array.prototype.map.call(caselle(d), function (i) { return [i, i.checked]; });
      d.removeAttribute('data-sp-dirty');
      d.removeAttribute('data-sp-applied');
      return;
    }
    /* chiusa senza „Anwenden": si torna alla fotografia */
    if (d.getAttribute('data-sp-dirty') === '1' && d.getAttribute('data-sp-applied') !== '1' && d.__spFoto) {
      d.__spFoto.forEach(function (p) { p[0].checked = p[1]; ridisegna(p[0]); });
      d.removeAttribute('data-sp-dirty');
    }
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-sp-dd-close], [data-sp-dd-apply]');
    if (!b) return;
    var d = b.closest('details.sp-dd');
    if (!d) return;
    e.preventDefault();
    if (b.hasAttribute('data-sp-dd-apply')) {
      var form = d.closest('form');
      var cambiata = d.getAttribute('data-sp-dirty') === '1';
      d.setAttribute('data-sp-applied', '1');
      d.open = false;
      if (form && cambiata) {
        window.__spFiltriApplica = true;
        try { form.dispatchEvent(new Event('change', { bubbles: true })); } finally { window.__spFiltriApplica = false; }
      }
    } else {
      d.open = false;
    }
  });
})();
